import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { NavLink } from "react-router-dom";
import styled from "@emotion/styled";
import {
  Avatar,
  Breadcrumbs as MuiBreadcrumbs,
  Button,
  Card as MuiCard,
  CardActions,
  CardContent as MuiCardContent,
  CardMedia as MuiCardMedia,
  Chip as MuiChip,
  Divider as MuiDivider,
  Grid,
  Link,
  Typography as MuiTypography,
  AvatarGroup as MuiAvatarGroup,
} from "@mui/material";
import { spacing } from "@mui/system";
import useAppmedia from "hooks/useAppmedia";
import MediaUpload from "./MediaUpload";
import MusicList from "./MusicList";
// ----------------------------------------------------------------------
const Typography = styled(MuiTypography)(spacing);

const Divider = styled(MuiDivider)(spacing);
const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const REF_MODEL = "appmusic";
export default function LibMusicPage() {
  const { appmusics, getAppMusics } = useAppmedia();

  useEffect(() => {
    getAppMusics();
  }, []);
  if (!appmusics) return <></>;

  return (
    <>
      <Helmet title="Emeuse vidéos" />

      <Grid justifyContent="space-between" container spacing={10}>
        <Grid item>
          <Typography variant="h3" gutterBottom display="inline">
            Emeuse musique
          </Typography>

          <Breadcrumbs aria-label="Breadcrumb" mt={2}>
            <Link component={NavLink} to="/app">
              Accueil
            </Link>
            <Typography>Emeuse musique</Typography>
          </Breadcrumbs>
        </Grid>
        <Grid item>
          <MediaUpload
            refName={REF_MODEL}
            addLabel="Ajouter des morceaux de musique"
            mediaType="audio"
          />
        </Grid>
      </Grid>

      <Divider my={6} />

      {appmusics && (
        <MusicList
          items={appmusics}
          musicField="filepath"
          refName={REF_MODEL}
        />
      )}
    </>
  );
}
